import _isEmpty from 'lodash/isEmpty';
import DateUtils from '../../utils/date/DateUtils';
export function filterFuturePosts() {
  var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var utcNow = DateUtils.getTimezoneAwareNow('UTC');
  return posts.filter(function (post) {
    var publishedAt = post.publishedAt;
    if (_isEmpty(publishedAt)) {
      return true;
    }
    return DateUtils.parseISO(publishedAt, 'UTC') <= utcNow;
  });
}